// ============================================================================
// LOAN MAPPING ENDPOINTS
// ============================================================================

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

const BASE_PATH = '/lmms/v1/loan-mappings';

export const loanMappingEndpoints = {
  list: () => buildEndpoint(BASE_PATH),
  getById: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  reportDetail: () => buildEndpoint(`${BASE_PATH}/report-detail`),
  getByCustomerId: (customerId: string) => buildEndpointWithParams(`${BASE_PATH}/by-customer/:customerId`, { customerId }),
  searchByAccount: (accountNumber?: string, glNumber?: string) => {
    const params = new URLSearchParams();
    if (accountNumber) params.append('accountNumber', accountNumber);
    if (glNumber) params.append('glNumber', glNumber);
    return buildEndpoint(`${BASE_PATH}/search-by-account?${params.toString()}`);
  },
  amendAccount: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id/amend-account`, { id }),
  amendGl: (id: ID, glId: ID) => buildEndpointWithParams(`${BASE_PATH}/:id/amend-gl/:glId`, { id, glId }),
} as const;

export default loanMappingEndpoints;
